module.exports = __webpack_public_path__ + "img/ic_16_plus.f317ae14.svg";